import React, { useEffect, useState } from "react";
import Logo from "./Logo";

const NAV = [
  { label: "Vision", href: "#vision" },
  { label: "Divisions", href: "#divisions" },
  { label: "Experience", href: "#clients" },
  { label: "Global", href: "#world" },
  { label: "Team", href: "#leadership" },
  { label: "Voices", href: "#referrals" },
];

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[#0A2427]/90 backdrop-blur-md border-b border-light-translucent"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between h-20">
        <a href="#top" data-testid="logo-link" className="flex items-center">
          <Logo variant="light" />
        </a>

        <nav className="hidden lg:flex items-center gap-10" data-testid="primary-nav">
          {NAV.map((item) => (
            <a
              key={item.label}
              href={item.href}
              data-testid={`nav-link-${item.label.toLowerCase()}`}
              className="nav-link text-sm font-medium text-white/80 hover:text-white transition-colors"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <a
          href="#footer"
          data-testid="header-contact-cta"
          className="hidden md:inline-flex items-center gap-2 px-5 py-2.5 border border-white/30 hover:border-[#2EC4B6] hover:bg-[#2EC4B6] hover:text-[#0A2427] transition-all duration-300 text-sm font-medium text-white"
        >
          Get in touch
          <span aria-hidden="true">→</span>
        </a>
      </div>
    </header>
  );
};

export default Header;
